import { IEnvConfig } from 'interfaces/i-env-config';
import { LoginMethod } from 'lib_ts/enums/auth.enums';
import { LanguageCode } from 'lib_ts/enums/translation';

export const ENV_PROD: IEnvConfig = {
  identifier: 'prod',
  maintenance: false,
  strict: false,
  use_radix: false,

  production: true,
  languages: [LanguageCode.English],

  debug_messages: false,
  region_redirect: true,
  run_tests: false,

  self_url: 'https://trajektsports.app',
  server_url: 'https://trajektsports.app/node',
  ws_url: 'https://trajektsports.app/users',
  ws_path: '/socket.io/',

  login_methods: [LoginMethod.Auth0, LoginMethod.Legacy],

  liveboard_url: 'https://live.trajektsports.app',

  enable: {
    change_language: false,

    vitals: false,

    sample_lists: false,

    toggle_rapid: true,

    pitch_upload_avg_release: true,
    pitch_upload_avg_chars: false,

    toggle_plate_shots: false,
    toggle_plate_debug: false,
    toggle_plate_safety_controls: false,
    toggle_plate_ellipses: true,
  },

  integrations: {
    intercom_app_id: 'tas54ol3',

    auth0: {
      domain: 'trajektsports.us.auth0.com',
      audience: 'https://trajektsports.us.auth0.com/api/v2/',
      clientId: 'DqVE1BEpZTxs7COi7gJVPBU6ckbkNqcS',
    },

    sentry: {
      enabled: true,
      dsn: 'https://d788b74980a6ee68987343d048d92b41@o4509952079429632.ingest.us.sentry.io/4509967840378880',
      environment: 'production',
      trace_sample_rate: 0,
    },
  },
};
